import type { Game } from 'app/CasinoGames/types';

// The game's own page, /game/:vendor/:slug (engines/brand_xo/config/routes.rb). A game without a
// slug has no page yet (see casino_games:backfill_slugs).
const gamePath = (game: Game): string | null => (game.slug ? `/game/${game.vendorSlug as string}/${game.slug}` : null);

export default gamePath;
